import { render, staticRenderFns } from "./EliminarUsuario.vue?vue&type=template&id=378840e6"
import script from "./EliminarUsuario.vue?vue&type=script&lang=js"
export * from "./EliminarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports